.root {
    border-top: 1px solid var(--border-color);
    padding-top: 16px;
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.title {
    display: flex;
    align-items: center;
    gap: 6px;
}

.helpIcon {
    width: 18px;
    height: 18px;
    padding: 0 !important;
    color: #6b7280 !important;
}

.notice {
    margin-top: 8px;
}

.addButton {
    width: 100%;
    justify-content: center;
    border-style: dashed !important;
}

.settings {
    display: grid;
    grid-template-columns: minmax(220px, 1fr) 180px;
    gap: 12px;
}

.actions {
    display: flex;
    justify-content: flex-end;
}

.saveButton {
    height: 37.13px;
}

.schedule {
    display: grid;
    gap: 4px;
}

.dayRow {
    display: grid;
    grid-template-columns: 96px 1fr;
    align-items: start;
    column-gap: 12px;
    min-height: 44px;
    padding: 8px;
    border-radius: 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.dayRow:hover {
    background-color: #fafafa;
}

.dayPrefix {
    display: flex;
    align-items: center;
    gap: 2px;
    margin-top: 2px;
}

.dayAvatar {
    min-width: 36px !important;
    width: 36px !important;
    height: 36px !important;
    border-radius: 50% !important;
    font-family: Outfit, sans-serif;
    font-size: 12px !important;
    font-weight: 700 !important;
    line-height: 1 !important;
    letter-spacing: 0.3px;
    flex-shrink: 0;
}

.dayAvatarOpen {
    background-color: var(--mui-palette-primary-main, #10b981) !important;
    color: #fff !important;
}

.dayAvatarClosed {
    background-color: rgba(0, 0, 0, 0.08) !important;
    color: rgba(0, 0, 0, 0.4) !important;
}

.windowList {
    display: grid;
    gap: 8px;
    align-content: center;
    min-height: 40px;
}

.windowRow {
    display: grid;
    grid-template-columns: minmax(120px, 150px) minmax(120px, 150px) 72px;
    align-items: center;
    gap: 8px;
}

.windowActions {
    display: flex;
    align-items: center;
    gap: 2px;
}

.emptyWindowRow {
    display: flex;
    align-items: center;
    gap: 4px;
}

.specialRow {
    grid-template-columns: 168px 1fr;
}

/* Matches .windowList's min-height so the date + switch center on the same
   axis as the first window row / "Closed all day" text. */
.specialPrefix {
    display: flex;
    align-items: center;
    gap: 2px;
    min-height: 40px;
}

.specialTitle {
    display: flex;
    align-items: center;
    gap: 6px;
    min-height: 24px;
    margin-top: 8px;
}

@media (max-width: 760px) {
    .settings {
        grid-template-columns: 1fr;
    }

    /* Keep avatar, switch, time selects and action icons on a single row,
       and tint the row so the schedule reads apart from the form inputs. */
    .dayRow {
        grid-template-columns: auto minmax(0, 1fr);
        column-gap: 8px;
        padding: 6px;
        background-color: #fafafa;
    }

    .specialRow {
        grid-template-columns: 1fr;
        row-gap: 8px;
        padding: 6px;
        background-color: #fafafa;
    }

    .dayAvatar {
        min-width: 28px !important;
        width: 28px !important;
        height: 28px !important;
        font-size: 10px !important;
    }

    /* Give each mobile time picker the full row width. Actions sit below so
       they do not reserve horizontal space beside the picker fields. */
    .windowRow {
        grid-template-columns: minmax(0, 1fr);
        grid-template-rows: auto auto auto;
        gap: 4px;
    }

    .windowRow > :nth-child(1) {
        grid-column: 1;
        grid-row: 1;
    }

    .windowRow > :nth-child(2) {
        grid-column: 1;
        grid-row: 2;
    }

    .windowActions {
        grid-column: 1;
        grid-row: 3;
        justify-content: flex-end;
    }

    .windowList {
        min-width: 0;
    }

    .header {
        flex-wrap: wrap;
    }

}
